import Amplify, { Auth } from "aws-amplify";

const oauthConfig = {
  domain: process.env.REACT_APP_COGNITO_DOMAIN,
  scope: [
    "phone",
    "email",
    "profile",
    "openid",
    "aws.cognito.signin.user.admin",
  ],
  redirectSignIn: `${process.env.REACT_APP_MY_URL}/auth`,
  redirectSignOut: `${process.env.REACT_APP_MY_URL}/login`,
  responseType: "token",
};

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_COGNITO_identityPoolId,
    region: process.env.REACT_APP_COGNITO_region,
    userPoolId: process.env.REACT_APP_COGNITO_userPoolId,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_userPoolWebClientId,
    oauth: oauthConfig,
  },

  // Keep the legacy top-level shape too; older code has worked with this config.
  oauth: oauthConfig,
});

export { Auth };
